class JklBurgerMenu extends HTMLElement {
	constructor() {
		super();
		this.header = document.querySelector(".header-wrapper");
		this.burgerMenu = this.querySelector(".jkl-burger-menu");
		this.openButton = this.querySelector(".jkl-burger-menu__toggle--open-btn");
		this.closeButtons = this.querySelectorAll(".jkl-burger-menu__toggle--close-btn");
		this.backButton = this.querySelector(".jkl-burger-menu__back-btn");
		this.overlay = this.querySelector(".jkl-burger-menu__overlay");
		this.currentSectionSpan = this.querySelector(".jkl-burger-menu__current-section");
		this.mainList = this.querySelector(".jkl-burger-menu__main-list");

		// Navigation state
		this.currentLevel = 1;
		this.navigationStack = [];
		this.targetMenuHandle = null;
		this.scrollY = 0;

		if (this.header) this.header.preventHide = false;

		this.setListeners();
		this.setupHeaderMenuTriggers();
	}

	setupHeaderMenuTriggers() {
		// Find all header menu items and convert them to burger menu triggers
		const headerMenuItems = document.querySelectorAll('.header__menu-item');

		headerMenuItems.forEach(menuItem => {
			// <a> elements are direct links with no submenu — let them navigate normally
			if (menuItem.tagName === 'A') return;

			const menuText = menuItem.textContent.trim();
			const menuHandle = this.getMenuHandleFromText(menuText);

			// Replace click behavior to open burger menu
			menuItem.addEventListener('click', (event) => {
				event.preventDefault();
				this.openToSection(menuHandle, menuText);
			});
		});
	}

	getMenuHandleFromText(text) {
		// Convert menu text to handle format (lowercase, replace spaces with hyphens)
		return text.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
	}

	openToSection(menuHandle, menuTitle) {
		this.targetMenuHandle = menuHandle;
		this.open();

		// Find and open the specific section
		const targetSummary = this.querySelector(`[data-menu-handle="${menuHandle}"]`);
		if (targetSummary) {
			setTimeout(() => {
				this.navigateToSection(targetSummary, menuTitle);
			}, 100);
		}
	}

	navigateToSection(summaryElement, title) {
		const details = summaryElement.closest('details');
		if (details) {
			// Open the details element
			details.open = true;
			details.classList.add('menu-opening');

			// Update navigation state
			this.currentLevel = 2;
			this.navigationStack.push({
				level: 1,
				title: 'Menu',
				element: this.mainList
			});

			// Update header
			this.updateNavigationHeader(title);

			// Show the submenu
			const submenu = details.querySelector('.jkl-burger-menu__submenu');
			if (submenu) {
				submenu.style.visibility = 'visible';
				submenu.style.transform = 'translateX(0)';
			}
		}
	}

	updateNavigationHeader(title) {
		// Update current section title
		this.currentSectionSpan.textContent = title;

		// Show/hide back button based on navigation stack
		if (this.navigationStack.length > 0) {
			this.backButton.style.display = 'flex';
		} else {
			this.backButton.style.display = 'none';
		}
	}

	goBack() {
		if (this.navigationStack.length > 0) {
			const previousLevel = this.navigationStack.pop();

			// If going back to level 1 (main menu), close the menu instead
			// This prevents users from seeing the main menu overview
			if (previousLevel.level === 1) {
				this.close();
				return;
			}

			this.currentLevel = previousLevel.level;

			// Get all open details and find the most deeply nested one (last in DOM order)
			const openDetailsElements = this.querySelectorAll('details[open].menu-opening');
			const openDetails = openDetailsElements[openDetailsElements.length - 1];
			const currentSubmenu = openDetails?.querySelector(':scope > .jkl-burger-menu__submenu');

			// Update header immediately
			if (this.navigationStack.length > 0) {
				const currentLevel = this.navigationStack[this.navigationStack.length - 1];
				this.updateNavigationHeader(currentLevel.title);
			} else {
				this.updateNavigationHeader('Menu');
			}

			if (currentSubmenu) {
				// Start the slide-out transition
				currentSubmenu.style.transform = 'translateX(100%)';

				// Only close the details AFTER the transition finishes so it can animate properly
				currentSubmenu.addEventListener('transitionend', () => {
					currentSubmenu.style.visibility = 'hidden';
					if (openDetails) {
						openDetails.open = false;
						openDetails.classList.remove('menu-opening');
					}
				}, { once: true });
			}
		}
	}

	lockScroll() {
		this.scrollY = window.scrollY || window.pageYOffset || 0;
		document.documentElement.classList.add("jkl-menu-open");
		document.body.classList.add("jkl-menu-open");
		document.body.style.top = `-${this.scrollY}px`;
	}

	unlockScroll() {
		const savedScrollY = Math.abs(parseInt(document.body.style.top || "0", 10));

		document.documentElement.classList.remove("jkl-menu-open");
		document.body.classList.remove("jkl-menu-open");
		document.body.style.top = "";

		window.scrollTo(0, savedScrollY);
	}

	open(event) {
		if (event) event.preventDefault();
		if (this.header) this.header.preventHide = true;

		const otherMenu = document.querySelector(".jkl-burger-menu--open");
		if (otherMenu && otherMenu !== this.burgerMenu) {
			this.close(event);
			otherMenu.classList.remove("jkl-burger-menu--open");
			otherMenu.querySelector(".jkl-burger-menu__overlay")?.classList?.remove("jkl-burger-menu__overlay--active");

			setTimeout(() => {
				this.burgerMenu.classList.add("jkl-burger-menu--open");
				this.overlay.classList.add("jkl-burger-menu__overlay--active");
				this.lockScroll();
				this.setDropdownWrapperPosition(this);
			}, 1000);
		} else {
			this.burgerMenu.classList.add("jkl-burger-menu--open");
			this.overlay.classList.add("jkl-burger-menu__overlay--active");
			this.lockScroll();
			this.setDropdownWrapperPosition(this);
		}
	}

	close(event) {
		if (event) event.preventDefault();

		this.burgerMenu.classList.remove("jkl-burger-menu--open");
		this.overlay.classList.remove("jkl-burger-menu__overlay--active");

		if (this.header) this.header.preventHide = false;

		this.burgerMenu.classList.add("hiding");
		this.unlockScroll();

		// Reset navigation only AFTER the wrapper has finished sliding out
		setTimeout(() => {
			this.burgerMenu.classList.remove("hiding");
			this.resetNavigation();
		}, 700);

		this.clearDropdownWrapperPosition();
	}

	resetNavigation() {
		this.currentLevel = 1;
		this.navigationStack = [];
		this.targetMenuHandle = null;
		this.updateNavigationHeader('Menu');

		// Instantly reset everything (menu is closing, no need to animate)
		const submenus = this.querySelectorAll('.jkl-burger-menu__submenu');
		submenus.forEach(submenu => {
			submenu.style.transition = 'none';
			submenu.style.visibility = 'hidden';
			submenu.style.transform = 'translateX(100%)';
			// Re-enable transitions after reset
			requestAnimationFrame(() => {
				submenu.style.transition = '';
			});
		});

		const openDetails = this.querySelectorAll('details[open]');
		openDetails.forEach(details => {
			details.open = false;
			details.classList.remove('menu-opening');
		});
	}

	setListeners() {
		this.openButton?.addEventListener("click", (event) => this.open(event));
		this.closeButtons?.forEach((item) =>
			item.addEventListener("click", (event) => this.close(event))
		);
		this.backButton?.addEventListener("click", (event) => {
			event.preventDefault();
			this.goBack();
		});
		this.overlay?.addEventListener("click", (event) => this.close(event));
		this.burgerMenu?.addEventListener(
			"keyup",
			(event) => event.code === "Escape" && this.close(event)
		);

		// Handle submenu navigation
		const submenuBacks = this.querySelectorAll('.jkl-burger-menu__submenu-back');
		submenuBacks.forEach(back => {
			back.addEventListener('click', (event) => {
				event.preventDefault();
				this.goBack();
			});
		});
	}

	setDropdownWrapperPosition(el) {
		const dropdownWrapper = el.querySelector('.jkl-burger-menu__dropdown-wrapper');
		if (!dropdownWrapper) return;

		const header = document.querySelector(".shopify-section-header");
		const burgerMenu = el.querySelector(".jkl-burger-menu");
		const burgerMenuOverlay = el.querySelector(".jkl-burger-menu__overlay");
		const calcTranslatePosition = `${this.getElementHeight(header)}px`;

		dropdownWrapper.style.transform = `translateY(0)`;
		burgerMenu.style.top = calcTranslatePosition;
		burgerMenuOverlay.style.top = calcTranslatePosition;
	}

	clearDropdownWrapperPosition() {
		const dropdownWrappers = document.querySelectorAll('.jkl-burger-menu__dropdown-wrapper');
		dropdownWrappers?.forEach((el) => {
			const header = document.querySelector(".shopify-section-header");
			const announcement = document.querySelector(".section-announcement");
			const countdownTimerBar = document.querySelector(".section-countdown-timer-bar");

			const calcTranslatePosition = this.getElementHeight(header) + this.getElementHeight(announcement) + this.getElementHeight(countdownTimerBar);
			el.style.transform = `translateY(calc(-100% - ${calcTranslatePosition}px))`;

			const burgerMenu = el.closest(".jkl-burger-menu");
			const burgerMenuOverlay = el.previousElementSibling;
			if (burgerMenu) {
				burgerMenu.style.top = 0;
			}
			if (burgerMenuOverlay) {
				burgerMenuOverlay.style.top = 0;
			}
		});
	}

	getElementHeight(el) {
		if (!el) return 0;

		if (this.isElementInViewport(el)) {
			return el?.getBoundingClientRect()?.height || 0;
		}
		return 0;
	}

	isElementInViewport(el) {
		const rect = el.getBoundingClientRect();
		return (
			rect.top < window.innerHeight &&
			rect.bottom > 0 &&
			rect.left < window.innerWidth &&
			rect.right > 0
		);
	}
}

// Custom element for menu drawer functionality within JKL burger menu
class JklMenuDrawer extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.onSummaryClick.bind(this));
	}

	onSummaryClick(event) {
		const summary = event.target.closest('summary');
		if (!summary) return;

		const details = summary.parentElement;
		const submenu = details.querySelector('.jkl-burger-menu__submenu');

		if (!details.open) {
			// Get the burger menu instance
			const burgerMenuElement = this.closest('jkl-burger-menu');

			// Get the current level from the summary's class
			const summaryClasses = summary.classList;
			let currentLevel = 1;
			if (summaryClasses.contains('jkl-level-2')) {
				currentLevel = 2;
			} else if (summaryClasses.contains('jkl-level-3')) {
				currentLevel = 3;
			}

			// Push current state to navigation stack
			if (burgerMenuElement) {
				const title = summary.getAttribute('data-menu-title') || summary.textContent.trim();
				burgerMenuElement.navigationStack.push({
					level: currentLevel,
					title: title,
					element: details
				});
				burgerMenuElement.currentLevel = currentLevel + 1;
			}

			setTimeout(() => {
				details.classList.add('menu-opening');
				if (submenu) {
					submenu.style.visibility = 'visible';
					submenu.style.transform = 'translateX(0)';
				}

				// Update the header with the submenu title
				if (burgerMenuElement) {
					const submenuTitle = summary.getAttribute('data-menu-title') || summary.textContent.trim();
					burgerMenuElement.updateNavigationHeader(submenuTitle);
				}
			}, 10);
		}
	}
}

if (!customElements.get("jkl-burger-menu")) {
	customElements.define("jkl-burger-menu", JklBurgerMenu);
}

if (!customElements.get("jkl-menu-drawer")) {
	customElements.define("jkl-menu-drawer", JklMenuDrawer);
}
